module.exports = __webpack_public_path__ + "images/leads_import_example.png";